<template>
    <v-dialog
        :value="visible"
        persistent
        transition="dialog-bottom-transition"
        :width="dialogWidth"
        @input="emitClose"
    >
        <v-card class="school-popup">
            <v-btn
                icon
                class="close-button"
                data-testid="school-popup-close"
                @click="emitClose"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="image-container">
                <component
                    :is="linkComponent"
                    v-if="hasImage"
                    v-bind="linkAttrs"
                    class="image-wrapper"
                    @click="handleLinkClick"
                >
                    <v-img
                        :src="computedImage"
                        contain
                        class="school-image"
                        max-width="100%"
                    />
                </component>
                <slot v-else />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        imageSrc: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
    },
    computed: {
        dialogWidth() {
            if (this.$vuetify && this.$vuetify.breakpoint.xsOnly) {
                return '95%'
            }
            if (this.$vuetify && this.$vuetify.breakpoint.smOnly) {
                return '70%'
            }
            if (this.$vuetify && this.$vuetify.breakpoint.mdOnly) {
                return '55%'
            }
            if (this.$vuetify && this.$vuetify.breakpoint.lgOnly) {
                return '45%'
            }
            return '40vw'
        },
        computedImage() {
            if (this.imageSrc) return this.imageSrc
            if (!this.$t) return ''
            const translation = this.$t('home.school_popup_image')
            return translation !== 'home.school_popup_image' ? translation : ''
        },
        hasImage() {
            return Boolean(this.computedImage)
        },
        linkComponent() {
            return this.link ? 'a' : 'div'
        },
        linkAttrs() {
            if (!this.link) return {}
            return {
                href: this.link,
                target: '_blank',
                rel: 'noopener noreferrer',
            }
        },
    },
    methods: {
        emitClose() {
            this.$emit('close')
        },
        handleLinkClick() {
            if (this.link) {
                this.$emit('link-click')
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.school-popup {
    border-radius: 16px;
    min-height: 20vh;
    text-align: center;
    position: relative;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-button {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 10;
}

.image-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.school-image {
    max-height: 85vh;
    width: 100%;
    object-fit: contain;
}

@media (max-width: 600px) {
    .school-popup {
        padding: 8px;
    }
}
</style>
